import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const propertySettingsService = {
  getSettings,
  updateSettings,
  getStates,
};

/**
 * Get property settings (business days, working hours, state)
 * @param {number} propertyId
 * @returns {Promise}
 */
function getSettings(propertyId) {
  return axios
    .get(apiEndpointFunction.propertySettings(propertyId), {
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error fetching property settings:', err);
      throw err;
    });
}

/**
 * Update property settings
 * @param {number} propertyId
 * @param {object} data - { business_days, working_hours_start, working_hours_end }
 * @returns {Promise}
 */
function updateSettings(propertyId, data) {
  return axios
    .put(apiEndpointFunction.propertySettings(propertyId), data, {
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error updating property settings:', err);
      throw err;
    });
}

/**
 * Get list of Australian states
 * @returns {Promise}
 */
function getStates() {
  return axios
    .get(`${apiEndpoint.propertySettings}/states`, {
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { states: [] };
    })
    .catch(err => {
      console.error('Error fetching states:', err);
      throw err;
    });
}
